import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function ProtectedRoute({
  isAllowed = false,
  redirectPath = "/",
  children,
}: {
  isAllowed: boolean;
  redirectPath: string;
  children?: React.ReactNode;
}) {
  const location = useLocation();

  if (!isAllowed) {
    // previousLocation lets the destination component navigate the user back to the desired location
    // once the user's authorization has been verified. In this case, it allows a user who is not logged in
    // to sign in and then land back on the page they were tryihng to access in the first place.
    return <Navigate to={redirectPath} state={{ previousLocation: location }} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
